/* Blocks add to cart until every personalisation field is filled.

   Fields are found by their property name rather than by position, and fields
   that are disabled are skipped. That matters because the photo grid disables
   the slots above the chosen variant and the name repeater disables the rows
   the customer collapsed - so the requirement follows what is actually on
   screen, not the markup that was rendered.

   Personalisation inputs on a product page sit outside the product form and are
   tied to it with the form attribute, so they are collected both ways.

   The add button is only re-enabled if this script was the thing that disabled
   it. Dawn disables the same button when a variant is sold out, and re-enabling
   that would let people buy what does not exist. */

(function () {
  if (window.__eoRequired) return;
  window.__eoRequired = true;

  function isCartAddForm(form) {
    return (form.getAttribute('action') || '').indexOf('/cart/add') !== -1;
  }

  function personalisationFields(form) {
    var all = [];
    var i;

    var inside = form.querySelectorAll('input[name^="properties["]');
    for (i = 0; i < inside.length; i++) all.push(inside[i]);

    var id = form.getAttribute('id');
    if (id) {
      var outside = document.querySelectorAll('input[form="' + id + '"][name^="properties["]');
      for (i = 0; i < outside.length; i++) all.push(outside[i]);
    }

    var wanted = [];
    for (i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.disabled) continue;
      if (el.type !== 'text' && el.type !== 'file') continue;
      var name = el.getAttribute('name') || '';
      if (name.indexOf('properties[Name ') === 0 || name.indexOf('properties[Photo ') === 0) {
        wanted.push(el);
      }
    }
    return wanted;
  }

  function isFilled(el) {
    if (el.type === 'file') return !!(el.files && el.files.length);
    return (el.value || '').trim().length > 0;
  }

  function noteFor(form, anchor) {
    var el = form.querySelector('.eo-required-note');
    if (el) return el;
    if (!anchor || !anchor.parentNode) return null;
    el = document.createElement('p');
    el.className = 'eo-required-note';
    el.setAttribute('role', 'status');
    anchor.parentNode.insertBefore(el, anchor);
    return el;
  }

  function wording(fields, missing) {
    var isPhoto = fields[0].type === 'file';
    if (isPhoto) {
      return missing === 1
        ? 'Add 1 more photograph to continue'
        : 'Add ' + missing + ' more photographs to continue';
    }
    return missing === 1
      ? 'Fill in 1 more name to continue'
      : 'Fill in ' + missing + ' more names to continue';
  }

  function check(form) {
    var fields = personalisationFields(form);
    if (!fields.length) return;

    var missing = 0;
    for (var i = 0; i < fields.length; i++) {
      if (!isFilled(fields[i])) missing++;
    }
    var ok = missing === 0;

    if (ok) {
      form.classList.remove('eo-invalid');
    } else {
      form.classList.add('eo-invalid');
    }

    var buttons = form.querySelectorAll('[name="add"], .eo-pair__submit');
    var anchor = null;

    for (var b = 0; b < buttons.length; b++) {
      var button = buttons[b];
      if (!anchor) anchor = button;

      if (!ok) {
        if (!button.disabled) {
          button.disabled = true;
          button.setAttribute('data-eo-locked', '');
        }
      } else if (button.hasAttribute('data-eo-locked')) {
        button.disabled = false;
        button.removeAttribute('data-eo-locked');
      }
    }

    var note = noteFor(form, anchor);
    if (!note) return;

    if (ok) {
      note.hidden = true;
      note.textContent = '';
    } else {
      note.hidden = false;
      note.textContent = wording(fields, missing);
    }
  }

  function checkAll() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      if (isCartAddForm(forms[i])) check(forms[i]);
    }
  }

  function schedule() {
    setTimeout(checkAll, 0);
  }

  document.addEventListener('input', schedule);
  document.addEventListener('change', schedule);
  document.addEventListener('click', schedule);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAll);
  } else {
    checkAll();
  }

  document.addEventListener('shopify:section:load', checkAll);
})();
